export default __webpack_public_path__ + "static/media/logo_En.0cc5b12c.png";